// MeasureModal — измерение выбранного тела: объём, площадь, габариты, масса.
// Масса = объём × плотность материала (образовательная ценность «сколько весит»).

import React, { useEffect, useState } from 'react';
import useCadStore from '../store/useCadStore';
import { getGeometryClient } from '../geometryClient';

// Плотности материалов, г/см³.
const MATERIALS = [
    { id: 'pla',      name: 'PLA (3D-печать)',   density: 1.24 },
    { id: 'abs',      name: 'ABS (3D-печать)',   density: 1.04 },
    { id: 'petg',     name: 'PETG (3D-печать)',  density: 1.27 },
    { id: 'resin',    name: 'Смола (SLA)',       density: 1.15 },
    { id: 'aluminum', name: 'Алюминий',          density: 2.70 },
    { id: 'steel',    name: 'Сталь',             density: 7.85 },
    { id: 'wood',     name: 'Дерево (сосна)',    density: 0.50 },
];

export default function MeasureModal({ onClose }) {
    const selection = useCadStore((s) => s.selection);
    const bodyMeshes = useCadStore((s) => s.bodyMeshes);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [matId, setMatId] = useState('pla');

    // Тело для измерения: выделенное, иначе первое.
    const bodyId = (selection.kind === 'body' && selection.ids.length === 1)
        ? selection.ids[0]
        : (bodyMeshes.size ? bodyMeshes.keys().next().value : null);

    useEffect(() => {
        let cancelled = false;
        if (!bodyId) { setError('Нет тела для измерения'); return; }
        setData(null); setError(null);
        getGeometryClient().measureBody(bodyId)
            .then((d) => { if (!cancelled) setData(d); })
            .catch((e) => { if (!cancelled) setError(e.message || String(e)); });
        return () => { cancelled = true; };
    }, [bodyId]);

    const mat = MATERIALS.find((m) => m.id === matId);
    // volume в мм³ → см³ (÷1000); масса (г) = см³ × плотность.
    const volCm3 = data?.volume != null ? data.volume / 1000 : null;
    const massG = volCm3 != null ? volCm3 * mat.density : null;

    const row = { display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #2a2f37' };
    const num = (v, digits = 2) => (typeof v === 'number' ? v.toFixed(digits) : '—');

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 3000, background: 'rgba(0,0,0,0.45)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={onClose}>
            <div style={{
                width: 420, maxWidth: '92vw', background: '#1a1d23',
                border: '1px solid #363b44', borderRadius: 8, color: '#e8ecf1',
                boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
            }} onClick={(e) => e.stopPropagation()}>
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '12px 16px', borderBottom: '1px solid #33383f',
                }}>
                    <b style={{ font: '15px system-ui' }}>Измерение тела</b>
                    <button onClick={onClose} style={{
                        background: 'none', border: 'none', color: '#9aa4b2', cursor: 'pointer', fontSize: 18,
                    }}>✕</button>
                </div>
                <div style={{ padding: '12px 16px', font: '13px system-ui' }}>
                    {error && <div style={{ color: '#cc6666' }}>{error}</div>}
                    {!error && !data && <div style={{ color: '#9aa4b2' }}>Считаю…</div>}
                    {data && (
                        <>
                            <div style={row}><span>Объём</span><b>{num(volCm3, 3)} см³</b></div>
                            <div style={row}><span>Площадь поверхности</span><b>{num(data.area != null ? data.area / 100 : null, 2)} см²</b></div>
                            {data.bbox && (
                                <div style={row}>
                                    <span>Габариты (Ш×Г×В)</span>
                                    <b>{num(data.bbox.size[0])}×{num(data.bbox.size[1])}×{num(data.bbox.size[2])} мм</b>
                                </div>
                            )}
                            {data.com && (
                                <div style={row}>
                                    <span>Центр масс</span>
                                    <b>{num(data.com[0])}, {num(data.com[1])}, {num(data.com[2])}</b>
                                </div>
                            )}
                            <div style={{ ...row, borderBottom: 'none', marginTop: 8, alignItems: 'center' }}>
                                <span>Материал</span>
                                <select value={matId} onChange={(e) => setMatId(e.target.value)} style={{
                                    background: '#20242b', border: '1px solid #363b44', color: '#e8ecf1',
                                    borderRadius: 4, padding: '4px 8px',
                                }}>
                                    {MATERIALS.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
                                </select>
                            </div>
                            <div style={{
                                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                marginTop: 8, padding: '10px 12px', background: '#20242b', borderRadius: 6,
                            }}>
                                <span>Масса</span>
                                <b style={{ font: '17px system-ui', color: '#8fd88f' }}>
                                    {massG != null ? (massG >= 1000 ? (massG / 1000).toFixed(2) + ' кг' : massG.toFixed(1) + ' г') : '—'}
                                </b>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
